import { Button } from "@mui/material";
import React from "react";

type BackButtonProps = {
  children: React.ReactNode;
  mt?: number;
  onClick: () => void;
  color?: "primary" | "secondary";
};

const BackButton: React.FC<BackButtonProps> = ({
  children,
  mt = 0,
  onClick,
  color = "primary",
}) => {
  return (
    <Button
      variant="outlined"
      color={color}
      fullWidth
      onClick={onClick}
      sx={{ mt }}
    >
      {children}
    </Button>
  );
};

export default BackButton;
